module.exports = __webpack_public_path__ + "static/quaggoth-9f8ea3a7d61c680a0fcbe86635908847.jpg";